import React, {
    ReactNode,
    useCallback,
    useEffect,
    useLayoutEffect,
    useMemo,
    useState,
} from 'react';
import { TaskBoard } from 'widgets/TaskBoard';
import { TaskList } from 'widgets';

type ActiveTab = 'taskBoard' | 'taskList';
const tabsList = [
    {
        title: i18next.t('Pages.TaskBoard.tabsList.board'),
        value: 'taskBoard',
    },
    {
        title: i18next.t('Pages.TaskBoard.tabsList.list'),
        value: 'taskList',
    },
];

export const useTaskBoard = () => {
    const queryParams = new URLSearchParams(location.search);
    const initialTab = (queryParams.get('tab') as ActiveTab) || 'taskBoard';
    const [activeTab, setActiveTab] = useState<ActiveTab>(initialTab);

    useEffect(() => {
        const activeTab = queryParams.get('tab');

        const isCorrectQueryNameTab = activeTab === 'taskBoard' || activeTab === 'taskList';

        if (!activeTab) {
            queryParams.set('tab', isCorrectQueryNameTab ? activeTab : 'taskBoard');
        } else {
            queryParams.set('tab', isCorrectQueryNameTab ? activeTab : 'taskBoard');
            setActiveTab(isCorrectQueryNameTab ? activeTab : 'taskBoard');
        }
        window.history.pushState({}, '', `?${queryParams.toString()}`);
    }, []);
    const onChangeActiveTab = useCallback(
        (activeTab: ActiveTab) => {
            const queryParamsInCb = new URLSearchParams(location.search);
            setActiveTab(activeTab);
            queryParamsInCb.set('tab', activeTab);
            window.history.pushState({}, '', `?${queryParamsInCb.toString()}`);
        },
        [activeTab]
    );

    const tabsContentMap: Record<ActiveTab, ReactNode> = useMemo(
        () => ({
            taskBoard: <TaskBoard />,
            taskList: <TaskList />,
        }),
        []
    );

    useLayoutEffect(() => {}, []);
    return {
        activeTab,
        onChangeActiveTab,
        tabsList,
        tabsContentMap,
    };
};
